/**
 *
 * PublicAssetsLayout
 *
 */
// import { useIsMobile } from 'app/hooks/useIsMobile';
import * as React from 'react';

export interface PublicAssetsLayoutProps {
  children: React.ReactNode;
}

export function PublicAssetsLayout(props: PublicAssetsLayoutProps) {
  const { children } = props;
  // const { checkIsMobile } = useIsMobile();
  // const isMobile = checkIsMobile();
  return (
    <div
      style={{
        display: 'flex',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
        width: '100%',
        height: '100vh',
      }}
    >
      {children}
    </div>
  );
}
